'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionPlan = exports.SubscriptionType = undefined;
exports.getSubscriptionImage = getSubscriptionImage;

var _Product = require('./Product');

var SubscriptionType = exports.SubscriptionType = {
  OPERATOR_SSO: 'OPERATOR_SSO',
  OPERATOR_ACCOUNT: 'OPERATOR_ACCOUNT',
  WATERMARK: 'WATERMARK',
  GRACE_PERIOD: 'GRACE_PERIOD',
  INTERNAL_STORE: 'INTERNAL_STORE',
  ADOBE_PASS: 'ADOBE_PASS',
  APP_STORE: 'APP_STORE',
  PLAY_STORE: 'PLAY_STORE',
  RECURLY: 'RECURLY',
  AIRFIND: 'AIRFIND',
  GOODIE: 'GOODIE',
  STINGRAY_TRIAL: 'STINGRAY_TRIAL',
  CMS: 'CMS',
  GUEST: 'GUEST',
  NONE: 'NONE',
  PROMO_CODE: 'PROMO_CODE',
  OPERATOR_DEVICE: 'OPERATOR_DEVICE',
  SECURED_TOKEN: 'SECURED_TOKEN',
  ANONYMOUS: 'ANONYMOUS',
  PREAUTHORIZED: 'PREAUTHORIZED',
  OPERATOR_OAUTH: 'OPERATOR_OAUTH',
  VIP_FIXED_TRIAL: 'VIP_FIXED_TRIAL',
  VIP_INTERVAL_TRIAL: 'VIP_INTERVAL_TRIAL',
  UNLOCK: 'UNLOCK'
};

var SubscriptionPlan = exports.SubscriptionPlan = {
  NONE: 'NONE',
  GUEST: 'GUEST',
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
  PREMIUM_TRIAL: 'PREMIUM_TRIAL'
};

var subscriptionImages = {
  MusicSubscription: { id: 0, resourceName: 'music' },
  ClassicaSubscription: { id: 1, resourceName: 'classica' },
  QelloSubscription: { id: 2, resourceName: 'qello' },
  KaraokeSubscription: { id: 3, resourceName: 'karaoke' },
  KaraokeTsmSubscription: { id: 4, resourceName: 'tsm' }
};

function getSubscriptionImage(product) {
  var fileSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var resourceName = void 0;

  switch (product) {
    case _Product.PRODUCT_NAMES.Classica:
      resourceName = subscriptionImages.ClassicaSubscription.resourceName;
      break;
    case _Product.PRODUCT_NAMES.Karaoke:
      resourceName = subscriptionImages.KaraokeSubscription.resourceName;
      break;
    case _Product.PRODUCT_NAMES.KaraokeTsm:
      resourceName = subscriptionImages.KaraokeTsmSubscription.resourceName;
      break;
    case _Product.PRODUCT_NAMES.Qello:
      resourceName = subscriptionImages.QelloSubscription.resourceName;
      break;
    default:
      resourceName = subscriptionImages.MusicSubscription.resourceName;
  }
  return require('./../../res/images/subscription/' + resourceName + fileSuffix + ".png");
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Subscription.js
// module id = 415
// module chunks = 0